
(function ($, Drupal) {
  /**
   * Horizontal tabs functionality.
   */
   Drupal.behaviors.kinaxisTabs = {
    attach: function (context, settings) {
      $(once('kinaxisHorizontalTabs', '.paragraph--type--horizontal-tabs, .paragraph--type--vertical-tabs')).each(function () {
        // is this a vertical or horizontal tab?
        const isVertical = $(this).hasClass('paragraph--type--vertical-tabs');
        $('.paragraph--type--vertical-tabs .nav-tabs a[data-toggle="tab"]').each(function (i, el) {
          // get the href of the clicked tab and find the element with that id.
          const $target = $(this).attr('href');
          // find the sibling  .mobile-tab-content
          const $mobileTabContent = $(this).closest('li').find('.mobile-tab-content');
          if ($target && !$mobileTabContent.hasClass('copied')) {
            // copy the inner html of the target to the .mobile-tab-content
            $mobileTabContent.html($($target).html());
            // add the copied class to the .mobile-tab-content
            $mobileTabContent.addClass('copied');
          }
        });
        $('.paragraph--type--horizontal-tabs .nav-tabs a, .paragraph--type--vertical-tabs .nav-tabs a[data-toggle="tab"]').click(function (e) {
          e.preventDefault();
          $(this).tab('show');
          const $target = $(this).attr('href');
          // check for iframes in the target. if there is one. then reload the iframe to stop it from playing.
          if ($($target).closest('.paragraph--type--vertical-tabs').find('iframe').length) {
            $($target).closest('.paragraph--type--vertical-tabs').find('iframe').each(function () {
              $(this).attr('src', $(this).attr('src'));
            });
          }

          // if this is a vertical tab. get all the nav-tabs li.
          if (isVertical) {
            // get all the .nav-tabs lis
            const $lis = $(this).closest('.nav-tabs').find('li');
            // loop thru the lis.
            $lis.each(function () {
              // if the li is active and the button aria-expanded is false. then click the button.
              if ($(this).hasClass('active') && $(this).find('button').attr('aria-expanded') === 'false') {
                $(this).find('button').click();
              }

              // if the li is not active and the button aria-expanded is true. then click the button.
              if (!$(this).hasClass('active') && $(this).find('button').attr('aria-expanded') === 'true') {
                $(this).find('button').click();
              }
            });
          }

        });

        $('.paragraph--type--horizontal-tabs .nav-tabs a, .paragraph--type--vertical-tabs .nav-tabs a[data-toggle="tab"]').on('shown.bs.tab', function() {
          Drupal.blazy.run();
        });

      });
    }
  }

  /**
   * Animated Underline
   * Horizontal Tabs
  */
  Drupal.behaviors.underlineTabs = {
    attach: function (context, settings) {
      $(document).find('.nav-tabs:has(.nav-underline)').each(function initialize() {
        const $container = $(this);
        const $active = $container.find('li.active').first();
        const $underline = $container.find('.nav-underline');

        const left = $active.position().left;
        const width = $active.outerWidth();

        $underline.css({"left" : left , "width" : width});
      });

      $('.nav-tabs a[data-toggle="tab"]').on('show.bs.tab', function() {
        const $this = $(this);
        const $parent = $this.parent();
        const $container = $parent.closest('.nav-tabs');
        const $underline = $container.find('.nav-underline');

        const left = $parent.position().left;
        const width = $parent.outerWidth();

        $underline.css({"left" : left , "width" : width});
      });
    }
}
})(jQuery, Drupal);
